import styles from "./EmailForm.module.css";
import React, { useState } from "react";
import constants from "../../data/constants.json";
import { CopyToClipboard } from "react-copy-to-clipboard";

const EmailForm = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // 2秒後にメッセージを消す
  };
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>お問い合わせ</h2>
      <p className={styles.description}>
        ご質問やご意見がございましたら、以下のメールアドレスまでご連絡ください。
      </p>
      <CopyToClipboard text={constants.email} onCopy={handleCopy}>
        <button className={styles.copyButton}>{constants.email}</button>
      </CopyToClipboard>
      <div className={styles.messageContainer}>
        <p className={`${styles.copiedMessage} ${copied ? styles.visible : ""}`}>
          メールアドレスをコピーしました！
        </p>
      </div>
    </div>
  );
};

export default EmailForm;
